module.exports = __webpack_public_path__ + "static/media/scroll-preloader.29871a32.svg";